var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EventButton',{attrs:{"event":_vm.buttonEvent,"data":_vm.item,"label":_vm.$x.messages.results.addToCart}},[_c('template',{slot:"icon"},[_vm._t("icon")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }